export default "__VITE_ASSET__GFMcLi0n__"